import type { DeepReadonly } from 'ts-essentials';

export enum I18nExtensionType {
  TEXT = 'T0',
  AUDIO = 'T1',
  VIDEO = 'T2',
  IMAGE = 'T3',
  DICOM = 'T4',
  STAMP = 'T5',
  HUMAN_BRIDGE = 'T10',
  DOCUMENT = 'T11',
  // CASES
  CASE_REGISTER = 'T7',
  CASE_UPDATE = 'T8',
  CASE_TRANSFER = 'T9',
  // USER/CONTACTS
  USER_NAME_UPDATE = 'U1',
  USER_AVATAR_UPDATE = 'U2',
  CONTACT_LIST_UPDATE = 'U3',
  // GROUP
  GROUP_INVITATION = 'T6',
  GROUP_JOIN = 'G2',
  GROUP_MEMBER_LEAVE = 'G3',
  GROUP_NAME_UPDATE = 'G5',
  GROUP_AVATAR_UPDATE = 'G8',
  GROUP_LEAVE = 'G9',
  // OTHER
  REPLY = 'J1',
  LEGACY_RTC_CALL = 'S', // Used only for rendering old Skyway chat messages returned in chat history
  RTC = 'RTC',
  // HEART DISEASE PROTOCOLS // EVENT TYPES
  HEART_DISEASE_ARRIVAL_TO_HOSPITAL = 'C0',
  HEART_DISEASE_ECG_START = 'C1',
  HEART_DISEASE_ECG_INTERPRETATION = 'C2',
  HEART_DISEASE_CT_MRI_ECO_START = 'C3',
  HEART_DISEASE_CT_MRI_ECO_END = 'C4',
  HEART_DISEASE_BLOOD_PRESSURE_CONTROLLED = 'C5',
  HEART_DISEASE_BLOOD_TESTS_END = 'C6',
  HEART_DISEASE_MEDICATION = 'C7',
  HEART_DISEASE_INTO_ANGIO_SUITE = 'C8',
  HEART_DISEASE_INTO_ICU = 'C9',
  HEART_DISEASE_SESSION_END = 'C10',
  // STROKE PROTOCOLS // EVENT TYPES
  STROKE_TPA = 'E0',
  STROKE_ARRIVAL_TO_HOSPITAL = 'E1',
  STROKE_CT_MRI_START = 'E2',
  STROKE_CT_MRI_END = 'E3',
  STROKE_INTO_ANGIO_SITE = 'E4',
  STROKE_PUNCTURE = 'E5',
  STROKE_LESION_FIRST_PASS = 'E6',
  STROKE_RECANALIZATION = 'E7',
  STROKE_SESSION_END = 'E8',
}

export enum RtcMessageType {
  START_CALL = '0',
  CANCEL_CALL = '1',
  REJECT_CALL = '2',
  RINGING_STOP = '3',
  REFRESH_CALL = '4',
  INFORM_GROUP_CALL_STATUS = '5',
  RECORDING_STARTED = '6',
  RECORDING_ENDED = '7',
  INFORM_CALL_STATUS = '8',
}

export type I18nExtension = {
  type: string,
  args: string[],
  extraArgs: Record<string, string> | null,
};

export enum LegacyExtensionType {
  IMAGE = 'media_image',
  DICOM = 'media_dicom',
  STAMP = 'media_stamp',
  HUMAN_BRIDGE = 'media_xca',
  // CASES // EMERGENCY EVENTS // PROTOCOLS
  CASE_REGISTER = 'case_register',
  CASE_UPDATE = 'case_update',
  CASE_TRANSFER = 'case_transfer',
  EMERGENCY_EVENT = 'emergency_event',

  // GROUP
  GROUP_JOIN = 'group_invitation_accept',
  GROUP_MEMBER_LEAVE = 'group_kick',
  GROUP_NAME_UPDATE = 'group_update',
  GROUP_AVATAR_UPDATE = 'group_avatar_update',
}

export type LegacyExtension = {
  type: string,
  args: Record<string, string> & Partial<Record<'kicked', string[]>>
};

export type SenderInfo = {
  name: string | null,
  avatarUrl: string | null,
};

export type ChatState = 'composing' | 'paused';

export type ReadMessage = {
  id: string,
  seqId: number,
};

export type XmppMessage = DeepReadonly<{
  id: string,
  type: string,
  senderId: string,
  isFromSelf: boolean,
  seq: number | null,
  body: string | null,
  senderInfo: SenderInfo,
  roomJid: string,
  roomId: string,
  template: I18nExtension | null,
  legacy: LegacyExtension | null,
  isShortLived: boolean,
  chatState: ChatState | null,
  readMessage: ReadMessage | null,
  timestamp: Date | null,
}>;
